import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table, TableBody, TableRow, TableCell, TablePagination, TableHead } from '@material-ui/core';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import FormatDate from '../FormatDate';
import { withTranslation } from 'react-i18next';
import RestaurantType from '../constants/RestaurantType';

class MenuList extends Component {
    constructor(props) {
        super(props);

        this.color = this.props.color || '#000';
    }

    handleChangeRowsPerPage(event) {
        this.props.onMenusToDisplayChange(event.target.value);
    }

    render() {
        const { menus, restaurantId, totalMenuCount, page, rowsPerPage } = this.props;

        if (!menus) {
            return null;
        }

        return (
            <div>
                <Table>
                    <TableHead>
                        <TableCell>{this.props.t('Alkaen')}</TableCell>
                        <TableCell>{this.props.t('Päättyy')}</TableCell>
                        <TableCell>{this.props.t('Tyyppi')}</TableCell>
                        <TableCell></TableCell>
                    </TableHead>
                    <TableBody>
                        {menus.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((menu) => (
                            <TableRow key={menu.id}
                                component={Link}
                                to={{ pathname: `/restaurants/${restaurantId}/menus/${menu.id}` }}
                                style={{ textDecoration: 'none' }}>
                                <TableCell>{FormatDate(menu.date_from)}</TableCell>
                                <TableCell>{FormatDate(menu.date_to)}</TableCell>
                                <TableCell>{this.props.t(RestaurantType[menu.type])} {this.props.t('Menu')}</TableCell>
                                <TableCell style={{ textAlign: 'right' }}>
                                    <KeyboardArrowRight />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={totalMenuCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': this.props.t('Edellinen sivu'),
                    }}
                    nextIconButtonProps={{
                        'aria-label': this.props.t('Seuraava sivu'),
                    }}
                    labelRowsPerPage={this.props.t('Rivejä sivulla')}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
                    onChangePage={(e, page) => {
                        if (e) {
                            this.props.changePageNumber(page);
                        }
                    }}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage.bind(this)}
                />
            </div>
        );
    }
}

export default withTranslation()(MenuList);



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuList.js